/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Passwordresetemailsent3Inputs */

const en_passwordresetemailsent3 = /** @type {(inputs: Passwordresetemailsent3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We've sent a password reset link to ${i?.email}`)
};

const de_passwordresetemailsent3 = /** @type {(inputs: Passwordresetemailsent3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir haben einen Link zum Zurücksetzen des Passworts an ${i?.email} gesendet`)
};

/**
* | output |
* | --- |
* | "We've sent a password reset link to {email}" |
*
* @param {Passwordresetemailsent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordresetemailsent3 = /** @type {((inputs: Passwordresetemailsent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordresetemailsent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordresetemailsent3(inputs)
	return de_passwordresetemailsent3(inputs)
});
export { passwordresetemailsent3 as "passwordResetEmailSent" }